"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconOrderReopeningCart = void 0;
var React = __importStar(require("react"));
var styled_components_1 = require("styled-components");
var IconOrderReopeningCart = function (props) {
    var theme = styled_components_1.useTheme();
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("path", { fill: "#464650", d: "M20.5 5.001c.13 0 .259.05.355.145l3 3c.113.114.165.274.14.432-.025.158-.124.295-.266.367L20 10.849V20.5c0 .827-.673 1.5-1.5 1.5h-13c-.827 0-1.5-.673-1.5-1.5v-9.691L.277 8.947c-.143-.072-.244-.209-.27-.367-.026-.158.027-.32.14-.434l3-3c.096-.095.225-.145.355-.145.053 0 .106.008.157.024l3 1-.005.016C6.767 6.014 6.883 6 7 6h1.5c.276 0 .5.224.5.5s-.224.5-.5.5H7c-.143 0-.28.062-.373.168L5.28 10.022c.073-.01.145-.022.22-.022h13c.07 0 .136.012.202.021L17.33 7.276c-.085-.171-.256-.276-.447-.276H15.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h1.382c.168 0 .327.035.48.086l-.02-.061 3-1c.05-.016.104-.024.157-.024zM18.5 11h-13c-.275 0-.5.225-.5.5v9c0 .275.225.5.5.5h13c.277 0 .5-.225.5-.5v-9c0-.275-.223-.5-.5-.5zM12 16v3H7v-3h5zm-1 1H8v1h3v-1zm9.366-10.928l-2.165.722c.007.013.017.022.024.035l1.514 3.029 2.922-1.491-2.295-2.295zm-16.73 0L1.345 8.363l2.922 1.461 1.445-3.059-2.076-.693z" }),
            React.createElement("path", { fill: "#464650", d: "M13.223 7.084l-.74.493c.006-.026.017-.05.017-.077V3c0-.276-.224-.5-.5-.5s-.5.224-.5.5v4.5c0 .028.01.05.016.077l-.74-.493c-.23-.153-.54-.09-.692.139-.153.229-.091.54.139.693l1.5 1c.084.056.18.084.277.084.097 0 .193-.028.277-.084l1.5-1c.23-.153.292-.464.139-.693-.153-.23-.464-.292-.693-.14z" }),
            React.createElement("path", { d: "M0 0H24V24H0z" }),
            React.createElement("circle", { cx: 18, cy: 5, r: 4, fill: !!theme ? theme.colors.accent.base : '#EC008C' }),
            React.createElement("path", { fill: "#FFF", fillRule: "nonzero", d: "M18.207 6.67L18.207 5.35 19.521 5.35 19.521 4.942 18.207 4.942 18.207 3.628 17.799 3.628 17.799 4.942 16.479 4.942 16.479 5.35 17.799 5.35 17.799 6.67z" }))));
};
exports.IconOrderReopeningCart = IconOrderReopeningCart;
exports.IconOrderReopeningCart.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconOrderReopeningCart;
